import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { BackArrowIcon } from '../icon/icon';

interface LocationState {
  selectedType?: string;
  borderLine?: boolean;
}

const CommonHeader = ({ menuTitle }: any) => {
  const location = useLocation<LocationState>();
  const history = useHistory();
  const { selectedType, borderLine = false } = location.state || {};

  console.log(menuTitle);

  const backBtn = () => {
    history.goBack();
  };
  return (
    <HeaderContainer borderLine={borderLine}>
      <div onClick={backBtn}>
        <BackArrowIcon />
      </div>
      <div className="title">
        <span>
          {menuTitle}
          {selectedType
            ? selectedType === 'once'
              ? '일대차'
              : '마당차'
            : null}
        </span>
      </div>
    </HeaderContainer>
  );
};

export default CommonHeader;

//style
const HeaderContainer = styled.header<{
  borderLine: boolean;
}>`
  display: flex;
  position: relative;
  padding: 1.1rem 0.4rem;
  border-bottom: ${(props) =>
    props.borderLine ? '1px solid #F0F0F0' : 'none'};
  .title {
    font-size: 1.6rem;
    font-weight: 600;
    position: absolute;
    top: 1.9rem;
    left: 50%;
    transform: translateX(-50%);
  }
`;
